// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ot-2";
export var chatLink = "_ot-0";
export var chatText = "_ot-1";